import React from "react";
import "../../assets/css/vendor.bundle.css";
import "../../assets/css/style.css";
import "../../assets/css/theme.css";
import Navbar from "../common/NavBar";
import Footer from "../common/Footer";
import { Helmet } from "react-helmet-async";

const Contact = () => {
  return (
    <div>
      <Helmet>
        <title>Contact</title>
      </Helmet>
      <div className="site-header header-s1 is-sticky">
        <Navbar />
        {/* Banner/Slider */}
        <div className="page-head section row-vm light has-bg-image">
          <div
            className="imagebg bg-image-loaded"
            style={{
              backgroundImage: `url(${require("../../assets/images/page-inside-bg.jpg")})`,
            }}
          >
            <img
              src={require("../../assets/images/page-inside-bg.jpg")}
              alt="page-head"
            />
          </div>
          <div className="container">
            <div className="row text-center">
              <div className="col-md-12">
                <h2>Contact Us</h2>
                <div className="page-breadcrumb">
                  <ul className="breadcrumb">
                    <li>
                      <a href="/">Home</a>
                    </li>
                    <li className="active">
                      <span>Contact Us</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* #end Banner/Slider */}
      </div>
      {/* Section */}
      <div class="section section-pad">
        <div class="container">
          <div class="row">
            <div class="res-m-bttm">
              <div class="contact-information">
                <h4>Contact Information</h4>
                <div class="row">
                  <div class="col-sm-4 res-m-bttm">
                    <div class="contact-entry">
                      <h6>
                        <span style={{ color: "#1c4b82" }}>Afc Trades</span>
                      </h6>
                      <p>
                        20 Fenchurch St, City of London,
                        <br />
                        London EC3M 3BY, United Kingdom
                      </p>
                    </div>
                  </div>
                  <div class="col-sm-4 res-m-bttm">
                    <div class="contact-entry">
                      <h6>contact number</h6>
                      <p>
                        phone: 781-123-9865
                        <br />
                        toll free: 800-123-5689
                      </p>
                    </div>
                  </div>
                  <div class="col-sm-4 res-m-bttm">
                    <div class="contact-entry">
                      <h6>office hours</h6>
                      <p>
                        monday - friday
                        <br />
                        8:30am - 5:00pm
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* End Section */}

      <Footer />
    </div>
  );
};

export default Contact;
